<template>
  <vcase></vcase>
</template>

<script>
  import vcase from '../../components/case/Case.vue'
  export default {
    components: {
      vcase
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// App.vue?485ae4ee